var WSListeners = /* @__PURE__ */ ((WSListeners2) => {
  WSListeners2["connect"] = "connect";
  WSListeners2["disconnect"] = "disconnect";
  WSListeners2["error"] = "error";
  WSListeners2["publish"] = "publication";
  WSListeners2["subscribe"] = "subscribed";
  WSListeners2["join"] = "join";
  WSListeners2["leave"] = "leave";
  WSListeners2["unsubscribe"] = "unsubscribe";
  return WSListeners2;
})(WSListeners || {});
var WSNamespaces = /* @__PURE__ */ ((WSNamespaces2) => {
  WSNamespaces2["events"] = "sb-events";
  WSNamespaces2["seasons"] = "sb-seasons";
  WSNamespaces2["public"] = "public";
  WSNamespaces2["users"] = "users";
  WSNamespaces2["cashouts"] = "my-bets-cashouts";
  WSNamespaces2["stages"] = "sb-stages";
  WSNamespaces2["leagues"] = "sb-leagues";
  WSNamespaces2["lastBetSumUpdate"] = "last-bet-sum-update";
  WSNamespaces2["sessionSocket"] = "session-socket";
  WSNamespaces2["forecastUpdate"] = "public:sport-forecast-update";
  WSNamespaces2["userForecastUpdate"] = "sport-forecast-update-user";
  return WSNamespaces2;
})(WSNamespaces || {});
var WSPublicChannel = /* @__PURE__ */ ((WSPublicChannel2) => {
  WSPublicChannel2["sportbook"] = "sportsbook";
  WSPublicChannel2["exchangeRates"] = "exchange-rates";
  WSPublicChannel2["realTimeIncomingBets"] = "real-time-incoming-bets";
  WSPublicChannel2["oddsBooster"] = "odds-booster-desktop";
  WSPublicChannel2["oddsBoosterBanners"] = "odds-booster-banner-desktop";
  WSPublicChannel2["userRegistration"] = "user-registration";
  WSPublicChannel2["casinoGamesPlayersOnlineDesktop"] = "casino-online-players-desktop";
  WSPublicChannel2["casinoGamesPlayersOnlineMobile"] = "casino-online-players-mobile";
  WSPublicChannel2["casinoPlayersOnline"] = "casino-online-players";
  return WSPublicChannel2;
})(WSPublicChannel || {});
function formatChannelToProto(channel) {
  return channel.replace(
    /^([^:]+):(.+)$/,
    (_match, prefix, rest) => `${prefix}:proto:${rest}`
  );
}
class CentrifugeClient {
  constructor() {
    this.listenersSet = false;
    this.subscriptions = {};
    this.storedChannels = {
      [
        "sb-events"
        /* events */
      ]: [],
      [
        "public"
        /* public */
      ]: [],
      [
        "sb-seasons"
        /* seasons */
      ]: [],
      [
        "users"
        /* users */
      ]: [],
      [
        "sb-stages"
        /* stages */
      ]: [],
      [
        "sb-leagues"
        /* leagues */
      ]: [],
      [
        "my-bets-cashouts"
        /* cashouts */
      ]: [],
      [
        "last-bet-sum-update"
        /* lastBetSumUpdate */
      ]: [],
      [
        "public:sport-forecast-update"
        /* forecastUpdate */
      ]: [],
      [
        "sport-forecast-update-user"
        /* userForecastUpdate */
      ]: [],
      [
        "session-socket"
        /* sessionSocket */
      ]: []
    };
    this.callBackStore = {};
  }
  getFullChannelName({ channel, namespace, isProtoBuf }) {
    let fullChannelName = `${namespace}:${channel}`;
    if (isProtoBuf) {
      fullChannelName = formatChannelToProto(fullChannelName);
    }
    return fullChannelName;
  }
  assignEvents({ fullChannelName, callback }) {
    this.callBackStore[fullChannelName] = callback;
    this.subscriptions[fullChannelName].on(
      "publication",
      this.callBackStore[fullChannelName]
    );
  }
  subscribe({ callback, namespace, channel, isProtoBuf }) {
    const fullChannelName = this.getFullChannelName({ namespace, channel, isProtoBuf });
    if (this.subscriptions[fullChannelName]) {
      this.removeListeners(fullChannelName);
    }
    this.storedChannels[namespace].push(fullChannelName);
    this.subscriptions[fullChannelName] = this.handler.newSubscription(fullChannelName);
    this.assignEvents({ fullChannelName, callback });
    this.subscriptions[fullChannelName].subscribe();
  }
  connect() {
    this.handler.connect();
  }
  destroy() {
    if (this.handler) {
      this.handler.disconnect();
    }
  }
  isConnected() {
    return this.handler.state === "connected";
  }
  setPageHideListeners() {
    this.listenersSet = true;
    window.addEventListener("pagehide", this._closeConnection.bind(this), {
      capture: true
    });
    window.addEventListener("pageshow", this._restoreConnection.bind(this), {
      capture: true
    });
    window.addEventListener("beforeunload", this._closeConnection.bind(this), { capture: true });
  }
  _closeConnection(e) {
    if (e.persisted) return;
    this.destroy();
  }
  _restoreConnection(e) {
    if (!e.persisted) return;
    if (!this.isConnected()) {
      this.connect();
      this.resubscribeToAllExisting();
    }
  }
  resubscribeToAllExisting() {
    Object.values(this.subscriptions).forEach((sub) => {
      sub.subscribe();
    });
  }
  unsubscribeInactive({ namespace, channels, isProtoBuf }) {
    const activeSubscriptions = channels.map(
      (channel) => this.getFullChannelName({ namespace, channel, isProtoBuf })
    );
    const channelToUnsubscribe = this.storedChannels[namespace].filter(
      (channel) => !activeSubscriptions.includes(channel)
    );
    this.storedChannels[namespace] = this.storedChannels[namespace].filter(
      (channel) => activeSubscriptions.includes(channel)
    );
    channelToUnsubscribe.forEach((channel) => this.unsubscribe(channel));
  }
  unsubscribe(channel) {
    if (this.subscriptions[channel]) {
      this.subscriptions[channel].unsubscribe();
      this.removeListeners(channel);
    }
  }
  unsubscribeMany({ namespace, channels, isProtoBuf }) {
    channels.forEach((channel) => {
      this.unsubscribe(this.getFullChannelName({ namespace, channel, isProtoBuf }));
    });
  }
  removeListeners(channel) {
    this.subscriptions[channel].removeAllListeners();
    this.subscriptions[channel].off(
      "publication",
      this.callBackStore[channel]
    );
  }
  unsubscribeAll(namespace) {
    const channelsToUnsubscribe = Object.keys(this.subscriptions).filter(
      (fullChannelName) => fullChannelName.includes(`${namespace}:`)
    );
    channelsToUnsubscribe.forEach(
      (channels) => this.unsubscribe(channels)
    );
    this.storedChannels[namespace] = [];
  }
  subscribeAll({ namespace, channels, callback, isProtoBuf }) {
    if (this.handler.state !== "connected") {
      this.connect();
    }
    channels.filter(
      (channel) => !this.storedChannels[namespace].includes(
        this.getFullChannelName({ namespace, channel, isProtoBuf })
      )
    ).forEach((channel) => {
      const callbackWithChannelName = (message) => {
        callback(channel, message);
      };
      this.subscribe({
        namespace,
        callback: callbackWithChannelName,
        channel,
        isProtoBuf
      });
    });
  }
}
export {
  CentrifugeClient,
  WSListeners,
  WSNamespaces,
  WSPublicChannel,
  formatChannelToProto
};
